import { render, staticRenderFns } from "./ScoreRadar.vue?vue&type=template&id=6082bbcc"
import script from "./ScoreRadar.vue?vue&type=script&lang=js"
export * from "./ScoreRadar.vue?vue&type=script&lang=js"
import style0 from "./ScoreRadar.vue?vue&type=style&index=0&id=6082bbcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports